import { render, staticRenderFns, recyclableRender, components } from "./u-section.vue?vue&type=template&id=a3f2467a&scoped=true&"
var renderjs
import script from "./u-section.vue?vue&type=script&lang=js&"
export * from "./u-section.vue?vue&type=script&lang=js&"
import style0 from "./u-section.vue?vue&type=style&index=0&id=a3f2467a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f2467a",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-section/u-section.vue"
export default component.exports